<h1>Scholarship Details for: <span class="text-orange-400">{{details?.ScholarshipName}}</span></h1>
<mat-divider></mat-divider>
<p>
    View details about a scholarship.
    There are multiple tabs that can be viewed.
    To make changes to any of this info, go back and click the 'Edit' button on the Scholarship List table.
</p>

<div class="flex flex-col items-center">
    <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="center" class="w-[900px] m-[30px]">
        <mat-tab label="Requirements">
            <div class="flex flex-col items-center">
                <div class="my-[15px] w-[90%]">
                    <label><strong>Scholarship Overview / Selection Criteria:</strong></label>
                    <mat-card class="p-[10px] min-h-[29px] bg-gray-300">{{details?.Description}}</mat-card>
                </div>

                <div class="my-[15px] w-[90%]">
                    <label><strong>Scholarship Status:</strong></label>
                    <mat-card class="p-[10px] min-h-[29px] bg-gray-300">{{details?.Active ? 'Active' : 'Inactive'}}</mat-card>
                </div>

                <div class="my-[15px] w-[90%]">
                    <label><strong>Advertised?:</strong></label>
                    <mat-card class="p-[10px] min-h-[29px] bg-gray-300">{{details?.Advertised ? 'Advertised' : 'Not Advertised'}}</mat-card>
                </div>

                <div class="my-[15px] w-[90%]">
                    <label><strong>Min GPA:</strong></label>
                    <mat-card class="p-[10px] min-h-[29px] bg-gray-300">{{details?.MinGPA}}</mat-card>
                </div>

                <div class="my-[15px] w-[90%]">
                    <label><strong>Min SAT:</strong></label>
                    <mat-card class="p-[10px] min-h-[29px] bg-gray-300">{{details?.MinSAT}}</mat-card>
                </div>

                <div class="my-[15px] w-[90%]">
                    <label><strong>Min ACT:</strong></label>
                    <mat-card class="p-[10px] min-h-[29px] bg-gray-300">{{details?.MinACT}}</mat-card>
                </div>

                <div class="my-[15px] w-[90%]">
                    <label><strong>Min CLT:</strong></label>
                    <mat-card class="p-[10px] min-h-[29px] bg-gray-300">{{details?.MinCLT}}</mat-card>
                </div>

                <div class="my-[15px] w-[90%]">
                    <label><strong>Min Community Service:</strong></label>
                    <mat-card class="p-[10px] min-h-[29px] bg-gray-300">{{details?.MinCommunityService}}</mat-card>
                </div>

                <div class="my-[15px] w-[90%]">
                    <label><strong>Min Work Hours:</strong></label>
                    <mat-card class="p-[10px] min-h-[29px] bg-gray-300">{{details?.MinWorkHours}}</mat-card>
                </div>
            </div>
        </mat-tab>
        <mat-tab label="General">
            <div class="flex flex-col items-center">
                <div class="my-[15px] w-[90%]">
                    <label><strong>Master ID:</strong></label>
                    <mat-card class="p-[10px] min-h-[29px] bg-gray-300">{{details?.MasterID}}</mat-card>
                </div>

                <div class="my-[15px] w-[90%]">
                    <label><strong>Adult School Eligible?:</strong></label>
                    <mat-card class="p-[10px] min-h-[29px] bg-gray-300">{{details?.AdultSchoolEligible}}</mat-card>
                </div>

                <div class="my-[15px] w-[90%]">
                    <label><strong>Tech Training Usage Allowed?:</strong></label>
                    <mat-card class="p-[10px] min-h-[29px] bg-gray-300">{{details?.TechTrainingUsageAllowed}}</mat-card>
                </div>

                <div class="my-[15px] w-[90%]">
                    <label><strong>Hard Copy Application?:</strong></label>
                    <mat-card class="p-[10px] min-h-[29px] bg-gray-300">{{details?.HardCopyApp}}</mat-card>
                </div>

                <div class="my-[15px] w-[90%]">
                    <label><strong>Year Established:</strong></label>
                    <mat-card class="p-[10px] min-h-[29px] bg-gray-300">{{details?.YearEstablished}}</mat-card>
                </div>

                <div class="my-[15px] w-[90%]">
                    <label><strong>Scholarship Type (Financial):</strong></label>
                    <mat-card class="p-[10px] min-h-[29px] bg-gray-300">{{details?.ScholarshipType}}</mat-card>
                </div>

                <div class="my-[15px] w-[90%]">
                    <label><strong>School Year:</strong></label>
                    <mat-card class="p-[10px] min-h-[29px] bg-gray-300">{{details?.SchoolYear | schoolYear}}</mat-card>
                </div>

                <div class="my-[15px] w-[90%]">
                    <label><strong>Endowed Total (Amount Invested):</strong></label>
                    <mat-card class="p-[10px] min-h-[29px] bg-gray-300">{{details?.EndowedTotal}}</mat-card>
                </div>

                <div class="my-[15px] w-[90%]">
                    <label><strong>How Scholarship Paid:</strong></label>
                    <mat-card class="p-[10px] min-h-[29px] bg-gray-300">{{details?.HowScholarshipPaid}}</mat-card>
                </div>

                <div class="my-[15px] w-[90%]">
                    <label><strong>Commitment Form Received:</strong></label>
                    <mat-card class="p-[10px] min-h-[29px] bg-gray-300">{{details?.CommitmentFormReceived}}</mat-card>
                </div>

                <div class="my-[15px] w-[90%]">
                    <label><strong>Donor Terms Form Received:</strong></label>
                    <mat-card class="p-[10px] min-h-[29px] bg-gray-300">{{details?.DonorTermsFormReceived}}</mat-card>
                </div>

                <div class="my-[15px] w-[90%]">
                    <label><strong>Number of Scholarships Awarded:</strong></label>
                    <mat-card class="p-[10px] min-h-[29px] bg-gray-300">{{details?.NbrScholarshipsAwarded}}</mat-card>
                </div>

                <div class="my-[15px] w-[90%]">
                    <label><strong>Amount Awarded:</strong></label>
                    <mat-card class="p-[10px] min-h-[29px] bg-gray-300">{{details?.AmountAwarded}}</mat-card>
                </div>

                <div class="my-[15px] w-[90%]">
                    <label><strong>Total Amount Available:</strong></label>
                    <mat-card class="p-[10px] min-h-[29px] bg-gray-300">{{details?.TotalAmountAvailable}}</mat-card>
                </div>

                <div class="my-[15px] w-[90%]">
                    <label><strong>Scholarship Distribution:</strong></label>
                    <mat-card class="p-[10px] min-h-[29px] bg-gray-300">{{details?.ScholarshipDistribution}}</mat-card>
                </div>

                <div class="my-[15px] w-[90%]">
                    <label><strong>Renewal Eligibility Special Requirements:</strong></label>
                    <mat-card class="p-[10px] min-h-[29px] bg-gray-300">{{details?.RenewalEligibilitySpecialRequirements}}</mat-card>
                </div>

                <div class="my-[15px] w-[90%]">
                    <label><strong>Financial Need:</strong></label>
                    <mat-card class="p-[10px] min-h-[29px] bg-gray-300">{{details?.FinancialNeed}}</mat-card>
                </div>

                <div class="my-[15px] w-[90%]">
                    <label><strong>Narrowing - Students With/Without Jobs:</strong></label>
                    <mat-card class="p-[10px] min-h-[29px] bg-gray-300">{{details?.StudentEmploymentNarrowing}}</mat-card>
                </div>

                <div class="my-[15px] w-[90%]">
                    <label><strong>Narrowing - Donor Specfic:</strong></label>
                    <mat-card class="p-[10px] min-h-[29px] bg-gray-300">{{details?.DonorSpecficNarrowing}}</mat-card>
                </div>

                <div class="my-[15px] w-[90%]">
                    <label><strong>Ranking Priorities:</strong></label>
                    <mat-card class="p-[10px] min-h-[29px] bg-gray-300">{{details?.RankingPriorities}}</mat-card>
                </div>

                <div class="my-[15px] w-[90%]">
                    <label><strong>Selection Process:</strong></label>
                    <mat-card class="p-[10px] min-h-[29px] bg-gray-300">{{details?.SelectionProcess}}</mat-card>
                </div>

                <div class="my-[15px] w-[90%]">
                    <label><strong>Interviews Required:</strong></label>
                    <mat-card class="p-[10px] min-h-[29px] bg-gray-300">{{details?.InterviewsRequired}}</mat-card>
                </div>

                <div class="my-[15px] w-[90%]">
                    <label><strong>Number of Applicants To Interview:</strong></label>
                    <mat-card class="p-[10px] min-h-[29px] bg-gray-300">{{details?.NbrApplicantsToInterview}}</mat-card>
                </div>

                <div class="my-[15px] w-[90%]">
                    <label><strong>Interview Screening Notes:</strong></label>
                    <mat-card class="p-[10px] min-h-[29px] bg-gray-300">{{details?.InterviewScreeningNotes}}</mat-card>
                </div>

                <div class="my-[15px] w-[90%]">
                    <label><strong>Additional Info to Include in Award Letter:</strong></label>
                    <mat-card class="p-[10px] min-h-[29px] bg-gray-300">{{details?.AwardLetterInfoToInclude}}</mat-card>
                </div>

                <div class="my-[15px] w-[90%]">
                    <label><strong>Special Notes:</strong></label>
                    <mat-card class="p-[10px] min-h-[29px] bg-gray-300">{{details?.SpecialNotes}}</mat-card>
                </div>

                <div class="my-[15px] w-[90%]">
                    <label><strong>Transcripts Needed For Renewal?:</strong></label>
                    <mat-card class="p-[10px] min-h-[29px] bg-gray-300">{{details?.TranscriptsNeededForRenewal}}</mat-card>
                </div>

                <div class="my-[15px] w-[90%]">
                    <label><strong>Donor Presenting?:</strong></label>
                    <mat-card class="p-[10px] min-h-[29px] bg-gray-300">{{details?.DonorPresenting}}</mat-card>
                </div>

                <div class="my-[15px] w-[90%]">
                    <label><strong>Who Will Present:</strong></label>
                    <mat-card class="p-[10px] min-h-[29px] bg-gray-300">{{details?.WhoWillPresent}}</mat-card>
                </div>
            </div>
        </mat-tab>
        <mat-tab label="Contact Info">
            <div class="flex flex-col items-center">
                <div class="my-[15px] w-[90%]">
                    <label><strong>Donor Name:</strong></label>
                    <mat-card class="p-[10px] min-h-[29px] bg-gray-300">{{details?.DonorName}}</mat-card>
                </div>

                <div class="my-[15px] w-[90%]">
                    <label><strong>Donor Address:</strong></label>
                    <mat-card class="p-[10px] min-h-[29px] bg-gray-300">{{details?.DonorAddress}}</mat-card>
                </div>

                <div class="my-[15px] w-[90%]">
                    <label><strong>Donor City:</strong></label>
                    <mat-card class="p-[10px] min-h-[29px] bg-gray-300">{{details?.DonorCity}}</mat-card>
                </div>

                <div class="my-[15px] w-[90%]">
                    <label><strong>Donor State:</strong></label>
                    <mat-card class="p-[10px] min-h-[29px] bg-gray-300">{{details?.DonorState}}</mat-card>
                </div>

                <div class="my-[15px] w-[90%]">
                    <label><strong>Donor Zip:</strong></label>
                    <mat-card class="p-[10px] min-h-[29px] bg-gray-300">{{details?.DonorZip}}</mat-card>
                </div>

                <div class="my-[15px] w-[90%]">
                    <label><strong>Donor Phone:</strong></label>
                    <mat-card class="p-[10px] min-h-[29px] bg-gray-300">{{details?.DonorPhone}}</mat-card>
                </div>

                <div class="my-[15px] w-[90%]">
                    <label><strong>Donor Email:</strong></label>
                    <mat-card class="p-[10px] min-h-[29px] bg-gray-300">{{details?.DonorEmail}}</mat-card>
                </div>

                <div class="my-[15px] w-[90%]">
                    <label><strong>Additional Contact:</strong></label>
                    <mat-card class="p-[10px] min-h-[29px] bg-gray-300">{{details?.AdditionalContact}}</mat-card>
                </div>

                <div class="my-[15px] w-[90%]">
                    <label><strong>Secondary Address:</strong></label>
                    <mat-card class="p-[10px] min-h-[29px] bg-gray-300">{{details?.SecondaryAddress}}</mat-card>
                </div>

                <div class="my-[15px] w-[90%]">
                    <label><strong>Secondary City:</strong></label>
                    <mat-card class="p-[10px] min-h-[29px] bg-gray-300">{{details?.SecondaryCity}}</mat-card>
                </div>

                <div class="my-[15px] w-[90%]">
                    <label><strong>Secondary State:</strong></label>
                    <mat-card class="p-[10px] min-h-[29px] bg-gray-300">{{details?.SecondaryState}}</mat-card>
                </div>

                <div class="my-[15px] w-[90%]">
                    <label><strong>Secondary Zip:</strong></label>
                    <mat-card class="p-[10px] min-h-[29px] bg-gray-300">{{details?.SecondaryZip}}</mat-card>
                </div>

                <div class="my-[15px] w-[90%]">
                    <label><strong>Secondary Email:</strong></label>
                    <mat-card class="p-[10px] min-h-[29px] bg-gray-300">{{details?.SecondaryEmail}}</mat-card>
                </div>

                <div class="my-[15px] w-[90%]">
                    <label><strong>Secondary Phone:</strong></label>
                    <mat-card class="p-[10px] min-h-[29px] bg-gray-300">{{details?.SecondaryPhone}}</mat-card>
                </div>
            </div>
        </mat-tab>
        <mat-tab label="Schools">
            <div class="flex flex-col items-center">
                <div class="my-[15px] w-[90%]">
                    <label><strong>Applicant Pool:</strong></label>
                    <mat-card class="p-[10px] min-h-[29px] bg-gray-300">{{details?.ApplicantPool}}</mat-card>
                </div>
                <div class="my-[15px] w-[90%]">
                    <label><strong>School List:</strong></label>
                    <mat-card class="p-[10px] min-h-[29px] bg-gray-300">
                        @for (sch of details?.SchoolList; track sch.SchoolNumber) {
                        <div class="mb-[5px]">
                            ({{sch?.SchoolNumber}}) {{sch?.SchoolName}}
                        </div>
                        }
                    </mat-card>
                </div>
            </div>
        </mat-tab>
        <mat-tab label="Additional Requirements">
            <div class="flex flex-col items-center">
                <div class="my-[15px] w-[90%]">
                    <label><strong>Additional Question:</strong></label>
                    <mat-card class="p-[10px] min-h-[29px] bg-gray-300">{{details?.AdditionalQuestion}}</mat-card>
                </div>
                <div class="my-[15px] w-[90%]">
                    <label><strong>Additional Question Has Yes/No Response:</strong></label>
                    <mat-card class="p-[10px] min-h-[29px] bg-gray-300">{{details?.AqHaveYesNo ? 'Yes' : 'No'}}</mat-card>
                </div>
                <div class="my-[15px] w-[90%]">
                    <label><strong>Additional Question Yes/No Response Requires Yes To Submit:</strong></label>
                    <mat-card class="p-[10px] min-h-[29px] bg-gray-300">{{details?.AqYesRequired ? 'Yes' : 'No'}}</mat-card>
                </div>
                <div class="my-[15px] w-[90%]">
                    <label><strong>Additional Question Has Required Text Response:</strong></label>
                    <mat-card class="p-[10px] min-h-[29px] bg-gray-300">{{details?.AqHaveText ? 'Yes' : 'No'}}</mat-card>
                </div>
                <div class="my-[15px] w-[90%]">
                    <label><strong>Essay Subject:</strong></label>
                    <mat-card class="p-[10px] min-h-[29px] bg-gray-300">{{details?.EssaySubject}}</mat-card>
                </div>
                <div class="my-[15px] w-[90%]">
                    <label><strong>Employee Name:</strong></label>
                    <mat-card class="p-[10px] min-h-[29px] bg-gray-300">{{details?.EmployeeNameReq ? 'Required' : 'Not Required'}}</mat-card>
                </div>
                <div class="my-[15px] w-[90%]">
                    <label><strong>Employee Location:</strong></label>
                    <mat-card class="p-[10px] min-h-[29px] bg-gray-300">{{details?.EmployeeLocationReq ? 'Required' : 'Not Required'}}</mat-card>
                </div>
                <div class="my-[15px] w-[90%]">
                    <label><strong>Employee SSN:</strong></label>
                    <mat-card class="p-[10px] min-h-[29px] bg-gray-300">{{details?.EmployeeSSNReq ? 'Required' : 'Not Required'}}</mat-card>
                </div>
                <div class="my-[15px] w-[90%]">
                    <label><strong>Store Location Number:</strong></label>
                    <mat-card class="p-[10px] min-h-[29px] bg-gray-300">{{details?.StoreLocationNumberReq ? 'Required' : 'Not Required'}}</mat-card>
                </div>
                <div class="my-[15px] w-[90%]">
                    <label><strong>Account Name:</strong></label>
                    <mat-card class="p-[10px] min-h-[29px] bg-gray-300">{{details?.AccountNameReq ? 'Required' : 'Not Required'}}</mat-card>
                </div>
                <div class="my-[15px] w-[90%]">
                    <label><strong>Account Number:</strong></label>
                    <mat-card class="p-[10px] min-h-[29px] bg-gray-300">{{details?.AccountNumberReq ? 'Required' : 'Not Required'}}</mat-card>
                </div>
                <div class="my-[15px] w-[90%]">
                    <label><strong>Parent Name:</strong></label>
                    <mat-card class="p-[10px] min-h-[29px] bg-gray-300">{{details?.ParentNameReq ? 'Required' : 'Not Required'}}</mat-card>
                </div>
                <div class="my-[15px] w-[90%]">
                    <label><strong>Parent SSN:</strong></label>
                    <mat-card class="p-[10px] min-h-[29px] bg-gray-300">{{details?.ParentSSNReq ? 'Required' : 'Not Required'}}</mat-card>
                </div>
                <div class="my-[15px] w-[90%]">
                    <label><strong>Parent Organization:</strong></label>
                    <mat-card class="p-[10px] min-h-[29px] bg-gray-300">{{details?.ParentOrganizationReq ? 'Required' : 'Not Required'}}</mat-card>
                </div>
                <div class="my-[15px] w-[90%]">
                    <label><strong>Parent Department:</strong></label>
                    <mat-card class="p-[10px] min-h-[29px] bg-gray-300">{{details?.ParentDepartmentReq ? 'Required' : 'Not Required'}}</mat-card>
                </div>
                <div class="my-[15px] w-[90%]">
                    <label><strong>Scholarship Essay:</strong></label>
                    <mat-card class="p-[10px] min-h-[29px] bg-gray-300">{{details?.ScholarshipEssayReq ? 'Required' : 'Not Required'}}</mat-card>
                </div>
                <div class="my-[15px] w-[90%]">
                    <label><strong>Scholarship Essay 2:</strong></label>
                    <mat-card class="p-[10px] min-h-[29px] bg-gray-300">{{details?.ScholarshipEssay2Req ? 'Required' : 'Not Required'}}</mat-card>
                </div>
            </div>
        </mat-tab>
    </mat-tab-group>

    <div class="actions">
        <button mat-raised-button type="button" routerLink="/scholarship-list">Back</button>
    </div>
</div>